export const translations = {
  eng: {
    // Header and main content
    mainTitle: "Cybersecurity Assessment Platform",
    mainDescription: "Comprehensive security assessment combining network discovery, vulnerability scanning, technology stack analysis, web security evaluation, infrastructure assessment, and data breach monitoring with AI-powered insights.",
    globalLanguageToggle: "Display entire website in Japanese",
    
    // Form section
    formTitle: "Security Assessment Request",
    formDescription: "Request a comprehensive cybersecurity assessment for your domain.",
    
    // Form fields
    languageLabel: "🌐 Language *",
    englishOption: "English",
    japaneseOption: "Japanese",
    firstNameLabel: "First Name *",
    lastNameLabel: "Last Name *",
    emailLabel: "Email Address *",
    emailDescription: "(Cyber Risk Report will be delivered to this email address)",
    domainLabel: "Domain to Assess *",
    domainPlaceholder: "example.com",
    domainDescription: "Enter just the domain (e.g., example.com). Your email domain must match.",
    termsAgreement: "I agree to",
    termsOfService: "Terms of Service",
    termsAgreementEnd: "understand that I may only assess domains I own or have explicit permission to scan.",
    
    // Form placeholders
    firstNamePlaceholder: "First Name",
    lastNamePlaceholder: "Last Name",
    emailPlaceholder: "Email Address",
    
    // Form validation messages
    firstNameRequired: "First name is required",
    lastNameRequired: "Last name is required",
    emailRequired: "Email is required",
    emailInvalid: "Invalid email format",
    domainRequired: "Domain is required",
    domainInvalid: "Invalid domain format (e.g., example.com)",
    emailDomainMismatch: "Email domain must match or be related to the assessment domain",
    termsRequired: "You must agree to the Terms of Service",
    
    // Status messages
    emailVerified: "Verified",
    emailNotVerified: "Not Verified",
    verified: "verified",
    unverified: "unverified",
    
    // Submit button text
    submitting: "Submitting...",
    startAssessment: "Start Security Assessment",
    startSecurityAssessment: "Start Security Assessment",
    verifyEmail: "Verify Email",
    initializePayment: "Initialize Payment",
    
    // Payment modal
    completePayment: "Complete Payment",
    pay: "Pay",
    
    // Plan selection
    selectPlan: "Select Your Plan",
    payNow: "💳 Pay Now",
    
    // Plan names and features (UI text only)
    planNames: {
      monthly: "Per Report",
      yearly: "Yearly Plan"
    },
    planFeatures: {
      monthly: ["Vulnerability scan", "Standard report", "Email support"],
      yearly: ["Monthly vulnerability scan", "Detailed report", "Priority support",]
    },
    
    // Modal texts
    requestAdditionalReport: "Request Additional Report",
    yourCurrentSubscription: "Your Current Subscription Status",
    subscriptionStatus: "SUBSCRIPTION STATUS",
    nextScheduled: "NEXT SCHEDULED",
    active: "Active",
    oneTimePayment: "One-time payment",
    immediateScanInitiation: "Immediate scan initiation",
    reportDeliveredWithin1Hour: "Report delivered within 1 hour",
    separateFromMonthlySchedule: "Separate from your monthly schedule",
    cancel: "Cancel",
    purchaseAdditionalReport: "Purchase Additional Report",
    
    // Additional popup texts
    reportGenerationTakingLonger: "Report Generation Taking Longer",
    reportGenerationMessage: "This is taking longer than expected. Your report will be sent to:",
    reportGenerationClose: "You can safely close this window. We will email you when your report is ready.",
    close: "Close",
    
    // Additional report popup
    additionalReportDescription: "Your monthly reports will continue to be delivered automatically on your scheduled date. This is a separate, immediate scan that allows you to get an updated report right now without affecting your regular monthly delivery schedule.",
    additionalReportFeatures: [
      "Immediate scan initiation",
      "Report delivered within 1 hour", 
      "Separate from your monthly schedule"
    ],
    
    // Notification modal
    notification: "Notification",
    
    // Success modal
    paymentSuccessful: "Payment Successful!",
    paymentSuccessMessage: "🎉 Payment successful! You can now begin your domain assessment. Let's secure that cyberspace! 🚀",
    continue: "Continue",
    
    // Domain report buttons and labels
    backToAssessment: "Back to Assessment",
    downloadFullReport: "Download Full Report",
    sslSecured: "SSL Secured",
    overallRiskScore: "Overall Risk Score",
    
    // Domain report section headers
    dnsRecords: "DNS RECORDS",
    sslCertificate: "SSL CERTIFICATE",
    openPorts: "OPEN PORTS",
    httpHeaders: "HTTP HEADERS",
    detectedTechnologiesVulnerabilities: "DETECTED TECHNOLOGIES & VULNERABILITIES",
    
    // Port status labels
    open: "open",
    closed: "Closed",
    openLabel: "Open",
    
    // DNS validation
    dnsValid: "DNS Valid",
    
    // Domain report labels
    domainRank: "Domain Rank",
    adultContent: "Adult Content",
    parking: "Parking",
    riskyTld: "Risky TLD",
    
    // Loading states
    verifyingToken: "Loading...",
    reportGenerationLonger: "Report Generation Taking Longer",
    reportGenerationMessage: "This is taking longer than expected. Your report will be sent to:",
    reportGenerationClose: "You can safely close this window. We will email you when your report is ready.",
    
    // Footer
    poweredBy: "Powered by Almata",
    
    // Logo alt text
    almataLogo: "Almata Logo",
    almataCybersecurity: "Almata Cybersecurity",
    
    // Error messages
    serverError: "server error",
    failedToFetchPlans: "Failed to fetch plans",
    incompletePlansData: "Incomplete plans data",
    failedToInitializePayment: "Failed to initialize payment",
    anErrorOccurred: "An error occurred",
    
    // Token verification
    emailVerifiedSuccess: "Your email has been verified successfully. Please click on the Button for Report Scan",
    invalidOrExpiredVerificationToken: "Invalid or expired verification token. Please request a new one.",
    invalidToken: "Invalid token",
    verificationEmailSent: "Verification email sent! Please check your inbox.",
    
    // Assessment messages
    assessmentStarted: "Assessment started!",
    monthlyPlanMessage: "You are currently subscribed to a 12-month Cyber Risk Protection Plan with Almata Global.Your detailed Cyber Risk Report will be automatically generated and delivered to your registered email address each cycle — no action required from your side.",
    yearlyPlanMessage: "12 month plan",
    requestAdditionalReportFlag: "Request Additional Report",
    
    // Backend response messages
    reportCompilationMessage: "The Cyber Risk Report is being compiled and will be sent to your registered email within 30 minutes",
    
    // Processing states
    processing: "Processing...",
    
    // Plan types
    monthlySubscriber: "Monthly Subscriber",
    annualSubscriber: "Annual Subscriber",
    
    // Subscription description
    subscriptionDescription: "You have an active {planType} subscription that includes {reportType} reports. Your next regularly scheduled report will be generated automatically on {date}.",
    monthlyReports: "12 monthly",
    regularReports: "regular",
    
    // Currency and payment
    usd: "USD",
    jpy: "JPY",
    usdLower: "usd",
    jpyLower: "jpy",
    
    // Time intervals
    monthly: "Monthly",
    annual: "Annual",
    oneTime: "One Time",
    year: "year",
    one_time: "one_time",
    
    // Plan types for comparison
    monthlySubscriberText: "Monthly Subscriber",
    annualSubscriberText: "Annual Subscriber",
    
    // Error messages for Stripe components
    failedToConfirmPayment: "Failed to confirm payment",
    errorConfirmingPayment: "Error confirming payment",
    errorDuringPayment: "An error occurred during payment",
    
    // Error messages
    failedToFetchPlans: "Failed to fetch plans",
    incompletePlansData: "Incomplete plans data",
    planDataIncomplete: "Plan data is incomplete",
    selectedPlanDataIncomplete: "Selected plan data is incomplete",
    invalidToken: "Invalid token",
    
    // Loading and status messages
    verifyingToken: "Loading...",
    
    // Network status messages
    noInternetConnection: "No Internet Connection",
    offlineMessage: "You're offline. Please reconnect your internet and try again.",
    retryRefresh: "Retry (Refresh Page)",
    waitingForConnection: "Waiting for connection to come back...",
    offlineNote: "While offline, external scripts (like Stripe) may fail to load.",
    
    // Terms of Service
    cyberRiskReport: "Cyber Risk Report",
    scopeOfService: "Scope of Service",
    scopeDescription: "Almata Co., Ltd. (\"we\", \"our\", or \"Almata\") provides Cyber Risk Reports that analyze publicly available data associated with a client's domain, IP, or other digital assets. The service is intended to offer cybersecurity insights and recommendations to help reduce external cyber threats.",
    useOfService: "Use of Service",
    useDescription: "The Cyber Risk Report is for informational and risk awareness purposes only. The report does not guarantee the prevention of cyber incidents or vulnerabilities. You agree not to distribute or reproduce the report outside your organization without our prior written consent.",
    dataHandling: "Data Handling",
    dataDescription: "We do not collect or process any personal data directly from the client. All analyses are based on publicly accessible data (e.g., DNS, WHOIS, TLS, and OSINT sources). Our service is compliant with applicable privacy laws including GDPR and Japan's APPI.",
    intellectualProperty: "Intellectual Property",
    ipDescription: "All content in the report, including analysis, scoring methodology, and design, is the intellectual property of Almata and may not be reused or repurposed without permission.",
    limitationOfLiability: "Limitation of Liability",
    liabilityDescription: "Almata shall not be held liable for any damages or losses resulting from reliance on the report's findings. The service is provided \"as is\" and without warranties of any kind.",
    modificationAndTermination: "Modification and Termination",
    modificationDescription: "We reserve the right to modify the contents or scope of the Cyber Risk Report at any time. We may also suspend or terminate the service with advance notice in the event of misuse or non-payment.",
    governingLaw: "Governing Law",
    lawDescription: "This agreement shall be governed by the laws of Japan. Any disputes arising in connection with this service shall be resolved in the Tokyo District Court.",
    
    // Domain Report
    noDataReceived: "No data received from API",
    failedToLoadReport: "Failed to load report data",
    reportPdf: "report.pdf",
    loading: "Loading...",
    loadingSecurityReport: "Loading security report...",
    backToHome: "Back to Home",
    domainSecurityReport: "Domain Security Report",
    noSummaryAvailable: "No summary available.",
    domain: "Domain",
    ipAddress: "IP Address",
    networkPerformance: "Network Performance",
    server: "Server",
    rootDomain: "Root Domain",
    city: "City",
    region: "Region",
    country: "Country",
    countryCode: "Country Code",
    isp: "ISP (Internet Service Provider)",
    latitude: "Latitude",
    longitude: "Longitude",
    timezone: "Timezone",
    zip: "ZIP",
    dnssec: "DNSSEC",
    registrar: "Registrar",
    registrarUrl: "Registrar URL",
    signed: "signed",
    unsigned: "unsigned",
    na: "N/A",
    
    // Additional Domain Report fields
    registrantCountry: "Registrant Country",
    registrantStateProvince: "Registrant State/Province",
    registrantEmail: "Registrant Email",
    nameServers: "Name Servers",
    registrarAbuseContact: "Registrar Abuse Contact",
    registrarWhoisServer: "Registrar WHOIS Server",
    
    // Coupon functionality
    couponCode: "Coupon Code",
    couponCodePlaceholder: "Enter coupon code",
    applyCoupon: "Apply Coupon",
    couponApplied: "Coupon applied successfully!",
    couponInvalid: "Invalid coupon code",
    couponInvalidForPlan: "Coupon is not valid for this plan",
    couponExpired: "Coupon has expired",
    couponAlreadyUsed: "Coupon already used",
    discountApplied: "Discount applied",
    originalPrice: "Original Price",
    discountedPrice: "Discounted Price",
    removeCoupon: "Remove Coupon",
    
    // Additional status messages and labels
    success: "Success!",
    errorLoadingReport: "Error loading report",
    noReportDataAvailable: "No report data available",
    expired: "Expired",
    unknown: "Unknown",
    listed: "Listed",
    clean: "Clean",
    present: "Present",
    notPresent: "Not Present",
    detected: "Detected",
    notDetected: "Not Detected",
    highRisk: "High Risk",
    lowRisk: "Low Risk",
    valid: "Valid",
    invalid: "Invalid",
    none: "None",
    yes: "Yes",
    no: "No",
    scanId: "Scan ID",
    noBreachesFound: "No Breaches Found",
    switchToEnglish: "Switch to English",
    switchToJapanese: "Switch to Japanese",
    breachDetected: "Breach Detected",
    pleaseSubmitDomainFirst: "Please submit a domain for assessment first",
    packetLoss: "Packet Loss",
    rtt: "RTT",
    exploitability: "Exploitability",
    impact: "Impact",
    baseScore: "Base Score",
    copyrightText: "Almata Co., Ltd. All rights reserved."
  },
  
  ja: {
    // Header and main content
    mainTitle: "サイバーセキュリティ評価プラットフォーム",
    mainDescription: "ネットワーク発見、脆弱性スキャン、技術スタック分析、ウェブセキュリティ評価、インフラストラクチャ評価、AI駆動の洞察によるデータ侵害監視を組み合わせた包括的なセキュリティ評価。",
    globalLanguageToggle: "ウェブサイト全体を日本語で表示",
    
    // Form section
    formTitle: "セキュリティ評価リクエスト",
    formDescription: "ドメインの包括的なサイバーセキュリティ評価をリクエストしてください。",
    
    // Form fields
    languageLabel: "🌐 言語 *",
    englishOption: "English",
    japaneseOption: "Japanese",
    firstNameLabel: "名 *",
    lastNameLabel: "姓 *",
    emailLabel: "メールアドレス *",
    emailDescription: "(サイバーリスクレポートはこのメールアドレスに配信されます)",
    domainLabel: "評価対象ドメイン *",
    domainPlaceholder: "example.com",
    domainDescription: "ドメインのみを入力してください（例：example.com）。メールドメインと一致する必要があります。",
    termsAgreement: "利用規約に同意し、",
    termsOfService: "利用規約",
    termsAgreementEnd: "所有するドメインまたは明示的なスキャン許可を持つドメインのみを評価することを理解します。",
    
    // Form placeholders
    firstNamePlaceholder: "名",
    lastNamePlaceholder: "姓",
    emailPlaceholder: "メールアドレス",
    
    // Form validation messages
    firstNameRequired: "名は必須です",
    lastNameRequired: "姓は必須です",
    emailRequired: "メールアドレスは必須です",
    emailInvalid: "無効なメール形式です",
    domainRequired: "ドメインは必須です",
    domainInvalid: "無効なドメイン形式です（例：example.com）",
    emailDomainMismatch: "メールドメインは評価対象ドメインと一致または関連している必要があります",
    termsRequired: "利用規約に同意する必要があります",
    
    // Status messages
    emailVerified: "認証済み",
    emailNotVerified: "未認証",
    verified: "verified",
    unverified: "unverified",
    
    // Submit button text
    submitting: "送信中...",
    startAssessment: "セキュリティ評価を開始",
    startSecurityAssessment: "セキュリティ評価を開始",
    verifyEmail: "メールを認証",
    initializePayment: "支払いを初期化",
    
    // Payment modal
    completePayment: "支払いを完了",
    pay: "支払う",
    
    // Plan selection
    selectPlan: "プランを選択してください",
    payNow: "💳 今すぐ支払う",
    
    // Plan names and features (UI text only)
    planNames: {
      monthly: "レポート毎",
      yearly: "年間プラン"
    },
    planFeatures: {
      monthly: ["脆弱性スキャン", "標準レポート", "メールサポート"],
      yearly: ["月次脆弱性スキャン", "詳細レポート", "優先サポート"]
    },
    
    // Modal texts
    requestAdditionalReport: "追加レポートをリクエスト",
    yourCurrentSubscription: "現在のサブスクリプション状況",
    subscriptionStatus: "サブスクリプション状況",
    nextScheduled: "次回予定",
    active: "アクティブ",
    oneTimePayment: "一回払い",
    immediateScanInitiation: "即座にスキャンを開始",
    reportDeliveredWithin1Hour: "1時間以内にレポートを配信",
    separateFromMonthlySchedule: "月次スケジュールとは別",
    cancel: "キャンセル",
    purchaseAdditionalReport: "追加レポートを購入",
    
    // Additional popup texts
    reportGenerationTakingLonger: "レポート生成に時間がかかっています",
    reportGenerationMessage: "予想より時間がかかっています。レポートは以下に送信されます：",
    reportGenerationClose: "このウィンドウを安全に閉じることができます。レポートの準備ができたらメールでお知らせします。",
    close: "閉じる",
    
    // Additional report popup
    additionalReportDescription: "あなたの月次レポートは、スケジュールされた日付で自動的に配信を継続します。これは、通常の月次配信スケジュールに影響を与えずに、今すぐ更新されたレポートを取得できる、別個の即時スキャンです。",
    additionalReportFeatures: [
      "即座にスキャンを開始",
      "1時間以内にレポートを配信", 
      "月次スケジュールとは別"
    ],
    
    // Notification modal
    notification: "通知",
    
    // Success modal
    paymentSuccessful: "支払い完了！",
    paymentSuccessMessage: "🎉 支払いが完了しました！ドメイン評価を開始できます。サイバースペースを安全にしましょう！🚀",
    continue: "続行",
    
    // Domain report buttons and labels
    backToAssessment: "評価に戻る",
    downloadFullReport: "完全レポートをダウンロード",
    sslSecured: "SSL保護済み",
    overallRiskScore: "総合リスクスコア",
    
    // Domain report section headers
    dnsRecords: "DNSレコード",
    sslCertificate: "SSL証明書",
    openPorts: "オープンポート",
    httpHeaders: "HTTPヘッダー",
    detectedTechnologiesVulnerabilities: "検出された技術と脆弱性",
    
    // Port status labels
    open: "オープン",
    closed: "クローズ",
    openLabel: "オープン",
    
    // DNS validation
    dnsValid: "DNS有効",
    
    // Domain report labels
    domainRank: "ドメインランク",
    adultContent: "アダルトコンテンツ",
    parking: "パーキング",
    riskyTld: "リスクTLD",
    
    // Loading states
    verifyingToken: "トークンを認証中...",
    reportGenerationLonger: "レポート生成に時間がかかっています",
    reportGenerationMessage: "予想より時間がかかっています。レポートは以下に送信されます：",
    reportGenerationClose: "このウィンドウを安全に閉じることができます。レポートの準備ができたらメールでお知らせします。",
    
    // Footer
    poweredBy: "Almata提供",
    
    // Logo alt text
    almataLogo: "Almata Logo",
    almataCybersecurity: "Almata Cybersecurity",
    
    // Error messages
    serverError: "サーバーエラー",
    failedToFetchPlans: "プランの取得に失敗しました",
    incompletePlansData: "プランデータが不完全です",
    failedToInitializePayment: "支払いの初期化に失敗しました",
    anErrorOccurred: "エラーが発生しました",
    
    // Token verification
    emailVerifiedSuccess: "メールが正常に認証されました。レポートスキャンのボタンをクリックしてください",
    invalidOrExpiredVerificationToken: "無効または期限切れの認証トークンです。新しいものをリクエストしてください。",
    invalidToken: "無効なトークン",
    verificationEmailSent: "認証メールが送信されました！受信トレイを確認してください。",
    
    // Assessment messages
    assessmentStarted: "評価が開始されました！",
    monthlyPlanMessage: "現在、Almata Globalの12ヶ月サイバーリスク保護プランにサブスクライブしています。詳細なサイバーリスクレポートは自動的に生成され、各サイクルで登録されたメールアドレスに配信されます — あなたの側でアクションは必要ありません。",
    yearlyPlanMessage: "12ヶ月プラン",
    requestAdditionalReportFlag: "追加レポートをリクエスト",
    
    // Backend response messages
    reportCompilationMessage: "サイバーリスクレポートは30分以内にコンパイルされ、登録されたメールアドレスに送信されます",
    
    // Processing states
    processing: "処理中...",
    
    // Plan types
    monthlySubscriber: "月次購読者",
    annualSubscriber: "年間購読者",
    
    // Subscription description
    subscriptionDescription: "あなたは{planType}サブスクリプションを持っており、{reportType}レポートを含んでいます。次回の定期的なスケジュールレポートは{date}に自動的に生成されます。",
    monthlyReports: "12ヶ月",
    regularReports: "定期的",
    
    // Currency and payment
    usd: "USD",
    jpy: "JPY",
    usdLower: "usd",
    jpyLower: "jpy",
    
    // Time intervals
    monthly: "月次",
    annual: "年間",
    oneTime: "一回",
    year: "年",
    one_time: "一回",
    
    // Plan types for comparison
    monthlySubscriberText: "月次購読者",
    annualSubscriberText: "年間購読者",
    
    // Error messages for Stripe components
    failedToConfirmPayment: "Failed to confirm payment",
    errorConfirmingPayment: "Error confirming payment",
    errorDuringPayment: "An error occurred during payment",
    
    // Error messages
    failedToFetchPlans: "プランの取得に失敗しました",
    incompletePlansData: "プランデータが不完全です",
    planDataIncomplete: "Plan data is incomplete",
    selectedPlanDataIncomplete: "Selected plan data is incomplete",
    invalidToken: "無効なトークン",
    
    // Loading and status messages
    verifyingToken: "トークンを認証中...",
    
    // Network status messages
    noInternetConnection: "インターネット接続なし",
    offlineMessage: "オフラインです。インターネットに再接続して再試行してください。",
    retryRefresh: "再試行（ページを更新）",
    waitingForConnection: "接続が戻るのを待っています...",
    offlineNote: "オフライン中は、Stripeなどの外部スクリプトの読み込みに失敗する場合があります。",
    
    // Terms of Service
    termsOfService: "利用規約",
    cyberRiskReport: "サイバーリスクレポート",
    scopeOfService: "サービスの範囲",
    scopeDescription: "Almata株式会社（「当社」、「私たち」、または「Almata」）は、クライアントのドメイン、IP、またはその他のデジタル資産に関連する公開データを分析するサイバーリスクレポートを提供します。このサービスは、外部サイバー脅威の削減に役立つサイバーセキュリティの洞察と推奨事項を提供することを目的としています。",
    useOfService: "サービスの使用",
    useDescription: "サイバーリスクレポートは、情報提供とリスク認識の目的でのみ使用されます。レポートは、サイバーインシデントや脆弱性の防止を保証するものではありません。事前の書面による同意なしに、組織外でレポートを配布または複製しないことに同意します。",
    dataHandling: "データ処理",
    dataDescription: "当社は、クライアントから直接個人データを収集または処理しません。すべての分析は、公開アクセス可能なデータ（DNS、WHOIS、TLS、OSINTソースなど）に基づいています。当社のサービスは、GDPRや日本のAPPIを含む適用されるプライバシー法に準拠しています。",
    intellectualProperty: "知的財産",
    ipDescription: "レポートのすべてのコンテンツ（分析、スコアリング方法論、デザインを含む）は、Almataの知的財産であり、許可なしに再利用または転用することはできません。",
    limitationOfLiability: "責任の制限",
    liabilityDescription: "Almataは、レポートの調査結果に依存した結果として生じる損害や損失について責任を負いません。サービスは「現状のまま」提供され、いかなる種類の保証もありません。",
    modificationAndTermination: "変更と終了",
    modificationDescription: "当社は、サイバーリスクレポートの内容または範囲をいつでも変更する権利を留保します。また、悪用や未払いの場合、事前通知によりサービスの停止または終了を行う場合があります。",
    governingLaw: "準拠法",
    lawDescription: "本契約は日本の法律に準拠します。本サービスに関連して生じる紛争は、東京地方裁判所で解決されます。",
    
    // Domain Report
    noDataReceived: "APIからデータを受信できませんでした",
    failedToLoadReport: "レポートデータの読み込みに失敗しました",
    reportPdf: "レポート.pdf",
    loading: "読み込み中...",
    loadingSecurityReport: "セキュリティレポートを読み込み中...",
    backToHome: "ホームに戻る",
    domainSecurityReport: "ドメインセキュリティレポート",
    noSummaryAvailable: "サマリーが利用できません。",
    domain: "ドメイン",
    ipAddress: "IPアドレス",
    networkPerformance: "ネットワークパフォーマンス",
    server: "サーバー",
    rootDomain: "ルートドメイン",
    city: "都市",
    region: "地域",
    country: "国",
    countryCode: "国コード",
    isp: "ISP（インターネットサービスプロバイダー）",
    latitude: "緯度",
    longitude: "経度",
    timezone: "タイムゾーン",
    zip: "郵便番号",
    dnssec: "DNSSEC",
    registrar: "レジストラ",
    registrarUrl: "レジストラURL",
    signed: "署名済み",
    unsigned: "未署名",
    na: "N/A",
    
    // Additional Domain Report fields
    registrantCountry: "登録者国",
    registrantStateProvince: "登録者州/県",
    registrantEmail: "登録者メール",
    nameServers: "ネームサーバー",
    registrarAbuseContact: "レジストラ不正使用連絡先",
    registrarWhoisServer: "レジストラWHOISサーバー",
    
    // Coupon functionality
    couponCode: "クーポンコード",
    couponCodePlaceholder: "クーポンコードを入力",
    applyCoupon: "クーポンを適用",
    couponApplied: "クーポンが正常に適用されました！",
    couponInvalid: "無効なクーポンコード",
    couponInvalidForPlan: "このプランではクーポンが無効です",
    couponExpired: "クーポンの有効期限が切れています",
    couponAlreadyUsed: "クーポンは既に使用されています",
    discountApplied: "割引が適用されました",
    originalPrice: "元の価格",
    discountedPrice: "割引価格",
    removeCoupon: "クーポンを削除",
    
    // Additional status messages and labels
    success: "成功！",
    errorLoadingReport: "レポートの読み込みエラー",
    noReportDataAvailable: "レポートデータが利用できません",
    expired: "期限切れ",
    unknown: "不明",
    listed: "リスト化",
    clean: "クリーン",
    present: "存在",
    notPresent: "存在しない",
    detected: "検出",
    notDetected: "未検出",
    highRisk: "高リスク",
    lowRisk: "低リスク",
    valid: "有効",
    invalid: "無効",
    none: "なし",
    yes: "はい",
    no: "いいえ",
    scanId: "スキャンID",
    noBreachesFound: "侵害は検出されませんでした",
    switchToEnglish: "英語に切り替え",
    switchToJapanese: "日本語に切り替え",
    breachDetected: "侵害が検出されました",
    pleaseSubmitDomainFirst: "最初にドメインを評価用に送信してください",
    packetLoss: "パケットロス",
    rtt: "RTT",
    exploitability: "悪用可能性",
    impact: "影響",
    baseScore: "基本スコア",
    copyrightText: "Almata株式会社 全著作権所有。"
  }
};
